export const getVersion = () => import.meta.env.VITE_APP_VERSION_NUMBER;
export const getBuild = () => import.meta.env.VITE_APP_BUILD_NUMBER;
